import styled from 'styled-components';
import { Header, DatesFont, BodyFont, isFirefox } from '../../constants/titles';
import { tangerine } from '../../constants/colorConstants';

export const ResumeItemTitle = styled(Header)`
    margin-left: 4vw;
    font-size: 2rem;
    color: ${props => props.theme.colors.RESUME_ITEM_TITLE};
    @media (max-width: 800px) {
        font-size: 1.3rem;
    }
`;

export const ResumeItemSubtitle = styled(ResumeItemTitle)`
    font-size: 1.8rem;
    color: ${props => props.theme.colors.RESUME_ITEM_SUBTITLE};
    @media (max-width: 800px) {
        font-size: 1.2rem;
    }
`;

export const ResumeItemDate = styled(ResumeItemSubtitle)`
    font-family: ${DatesFont};
`;

export const ResumeItemInfo = styled(ResumeItemSubtitle)`
    font-family: ${BodyFont};
    padding-bottom: 5vh;
`;

export const ResumeBullet = styled.li`
    font-size: 1.6rem;
    @media (max-width: 800px) {
        font-size: 1rem;
    }
`;

export const Paragraph = styled(ResumeItemInfo)`
    font-size: 1.6rem;
`;

export const EmphasisText = styled.p`
    color: ${props => props.theme.colors.LINK_HOVER};
    font-weight: bold;
    display: inline;
`;

export const ResumeLink = styled.a`
    color: ${props => props.theme.colors.LINK};
    text-decoration: none!important;
    font-weight: bold;
    &:hover {
        color: ${props => props.theme.colors.LINK_HOVER};
    }
`;

export const AboutWrapper = styled.div`
    margin-top: 5vh;
    border-left: 5px solid ${props => props.theme.colors.SIDEBAR};
    text-align: left;
    margin-right: 10vh;
`;

export const PhotoBox = styled.div`
    width: 38vw;

    @media (max-width: 800px) {
        margin: auto;
    }
`;

export const PhotoContainer = styled.div`
    position: relative;
    width: 30vw;
    flex-shrink: 0;
    margin-left: 4vw;
    margin-bottom: 10vh;
    align-self: flex-start;

    @media (max-width: 1000px) {
        width: 55vw;
        margin-left: 5vw;
        margin-top: 4vh;
        margin-bottom: 12vh;
    }
    @media (max-width: 600px) {
        width: 70vw;
        margin-left: 5vw;
        margin-top: 3vh;
        margin-bottom: 10vh;
    }
`;

export const PrimaryPhoto = styled.img`
    width: 100%;
    height: auto;
    display: block;
    box-shadow: 20px 20px ${props => props.theme.colors.PHOTO_SHADOW};

    @media (max-width: 600px) {
        box-shadow: 12px 12px ${props => props.theme.colors.PHOTO_SHADOW};
    }
`;

export const SecondaryPhoto = styled.img`
    position: absolute;
    bottom: -45px;
    right: -24px;
    width: 48%;
    height: auto;
    box-shadow: 15px 15px ${tangerine};
    border: 4px solid ${props => props.theme.colors.PAGE_BACKGROUND};
    z-index: 2;
    transition: transform 0.3s ease;

    &:hover {
        transform: scale(1.05) translateY(-4px);
    }

    @media (max-width: 600px) {
        bottom: -25px;
        right: -10px;
        width: 45%;
        box-shadow: 10px 10px ${tangerine};
    }
`;

export const Photo = styled.img`
    width: ${isFirefox ? `300%` : `38%`};
    height: 100%;
    box-shadow: 20px 20px ${props => props.theme.colors.PHOTO_SHADOW};
    margin-left: 4vw;

    margin-bottom: 10vh;
    @media (max-width: 1000px) {
        width: 38vw;
        margin: auto;
        margin-bottom: 10vh;
    }
`;

export const PhotoWrapper = styled.div`
    display: flex;
    @media (max-width: 1000px) {
        flex-direction: column;
    }
`;